/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Login_Methods_DescriptionInputs */



/**
* | output |
* | --- |
* | "Which ways this member may sign in. Passkeys are not listed: they are a credential the member registers themselves and stay available regardless. Use \"Reset ..." |
*
* @param {Member_Login_Methods_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_login_methods_description = /** @type {((inputs?: Member_Login_Methods_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Login_Methods_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf welchen Wegen sich dieses Mitglied anmelden darf. Passkeys stehen nicht in der Liste: Sie sind ein Zugangsmittel, das das Mitglied selbst einrichtet, und bleiben unabhängig davon nutzbar. Um diese zu entziehen, nutzen Sie „Zugangsdaten zurücksetzen“.")
	return /** @type {LocalizedString} */ ("Which ways this member may sign in. Passkeys are not listed: they are a credential the member registers themselves and stay available regardless. Use \"Reset credentials\" to withdraw those.")
});